


















































































































import settings from '@/settings'
import n from '@/utils/notifications'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import t from '@/utils/tools'
import Menus from '@/components/menus'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import Vue from 'vue'
import { Popover } from 'element-ui'
import popover_content from '@/components/popover_content'
import GanttChart from '@/components/gantt_chart'


export default {
    name: 'planning'

    components: { Menus, FullCalendar, Popover, GanttChart }

    data: ()->
        mode: 'agenda'
        updateData: null
        ical_link:''
        warning_text: 'Afin de créer un nouvel événement, un⋅e seul·e collaborateur⋅trice doit être sélectionné⋅e dans le menu déroulant.'
        ical_warning_text: 'Afin de générer le lien Ical, un⋅e seul·e collaborateur⋅trice doit être sélectionné⋅e dans le menu déroulant.'
        establishments_ready: false
        app_users_ready: false
        event_types_ready: false
        event_type_set: [
            {'value':'all', 'label': 'Tous types'}
        ]
        establishments: []
        app_users: []
        dialog_visible: false
        ical_dialog_visible: false
        picker_options: {firstDayOfWeek:1}
        errors: {}
        with_subordinates: false
        selected_establishments: []
        selected_event_types: ['all']
        selected_users: ['all']
        selected_event: {
            uid: ''
            user_uid: ''
            name: ''
            start: ''
            end: ''
            allday: false
        }
        trash_class: ''
        calendarOptions:
            dayCellDidMount: @dayRenderer
            plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin ]
            views:
                multiMonths:
                    type: 'dayGrid'
                    buttonText: '3 mois'
                    duration:
                        months: 3
            fixedWeekCount: false
            # showNonCurrentDates: false
            # initialDate: "2019-10-09"
            initialView: 'dayGridMonth'
            locale: "fr"
            weekends: true
            firstDay: 1
            dayHeaders: true
            # eventTimeFormat: 'h[h]mm'
            eventTimeFormat:
                hour: '2-digit'
                minute: '2-digit'
            buttonText:
                today: "Aujourd'hui"
                month: "Mois"
                week: "Semaine"
                day: "Jour"
            headerToolbar:
                left: 'prev,next today'
                center: 'title'
                right: 'multiMonths,dayGridMonth,timeGridWeek,timeGridDay'
            editable: true
            droppable: true
            dragRevertDuration: 0
            # eventSources: eventSources
            dateClick: @date_click
            eventClick: @event_click
            eventDragStart: @event_drag_start
            eventDragStop: @event_drag_stop
            eventResize: @save
            eventDrop: @save
            eventDidMount: @event_did_mount
            # viewDidMount: @changeView
            # viewWillUnmount: @bv
            # viewClassNames: @ef
            events: @get_calendar_events

    computed:
        dialog_title: ()->
            title = "Ajouter un événement"
            if @selected_event.uid != ''
                title = "Editer un événement"
            return title

        ws_disabled: ()->
            if @selected_users.length >= 1 and 'all' not in @selected_users
                return false
            return true

        has_establishments_right: ()->
            return @has_access_right('establishments_show')

    methods:
        has_access_right: t.has_access_right
        # bv: (arg)->
        #     console.log "UNMOUNT VIEW"

        # ef: (arg)->
        #     console.log "CLASS VIEW", arg.view.calendar, @$refs
        #     cal = @$refs.calendar.getApi()

        # changeView: (arg)->
        #     console.log "CHANGE VIEW"
        refetch_events: ()->
            if @mode == 'agenda'
                if @$refs.calendar?
                    cal = @$refs.calendar.getApi()
                    cal.refetchEvents()
            if @mode == 'gantt'
                @updateData = new Date().getTime()
            return

        reset_selected_event: ()->
            @selected_event = {
                uid: ''
                user_uid: ''
                name: ''
                start: ''
                end: ''
                allday: false
            }
            return

        reset_dialog: ()->
            @dialog_visible = false
            @reset_selected_event()
            return

        ical_reset_dialog: ()->
            @ical_dialog_visible = false
            return

        filtering_events: ()->
            # console.log "SELECTED establishments", @selected_establishments
            console.log "SELECTED users", @selected_users
            console.log "SELECTED event types", @selected_event_types
            # console.log "SELECTED with_subordinates", @with_subordinates
            @refetch_events()
            return

        dayRenderer: (day)->
            # console.log "DAY RENDERER ", day
            # console.log "DAY RENDERER ", day.el.classList.contains('fc-day-disabled')
            # isDisabled = day.el.classList.contains('fc-day-disabled')
            # if !isDisabled
            #     console.log "CHILD NOT DISABLED ", day.el.children[0].children[0]
            # else
            #     console.log "CHILD DISABLED ", day.el.children[0]
            div = document.createElement('div')
            div.innerHTML = day.date.toLocaleString('default', { month: 'short' })
            day.el.children[0].children[0].appendChild(div)
            div.style = 'width: 100%; text-align: center; padding-top: 4px; color: lightgray;'
            # if day.view.type == 'multiMonths'
            #     div.style = 'width: 100%; text-align: center; padding-top: 4px; color: lightgray;'
            # else
                # if day.dayNumberText == '1' and !isDisabled or day.date.getDay() == 1 and day.date.getDate() <= 6 and !isDisabled
                #     # console.log "IN IF ", day
                #     div = document.createElement('div')
                #     div.style = 'position:absolute; left:5px;'
                #     div.innerHTML = day.date.toLocaleString('default', { month: 'long' })
                #     day.el.children[0].children[0].appendChild(div)

                # if !isDisabled
                #     # // Change the background color of cells based on months
                #     campaignStartMonth = day.date.getMonth()
                #     campaignStartEven = campaignStartMonth % 2 == 0
                #     # console.log "START MONTH", campaignStartMonth, campaignStartEven, day.date.getMonth() % 2, day.date.getMonth() % 2 != 0
                #     # console.log campaignStartEven and day.date.getMonth() % 2 != 0
                #     # console.log !campaignStartEven and day.date.getMonth() % 2 == 0
                #     if day.date.getMonth() % 2 == 0
                #         # console.log "EVEN", day.date
                #         day.el.classList.add('bg-grey')

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        event_click: (info)->
            # console.log "EVENT CLICK START", info.event.start
            # console.log "EVENT CLICK END", info.event.end
            if info.event.startEditable
                @selected_event.name = info.event.title
                @selected_event.start = t.python_date_formatter(info.event.start)
                @selected_event.allday = info.event.allDay
                end = info.event.end
                if info.event.allDay
                    end = new Date(info.event.end.setDate(info.event.end.getDate()-1))
                    # console.log "$$$ END ", end
                @selected_event.end = t.python_date_formatter(end)
                @selected_event.uid = info.event.extendedProps.item_uid
                @selected_event.user_uid = info.event.extendedProps.user_uid
                # console.log "EVENT CLICK SELECTED ", @selected_event

                @dialog_visible = true
            return

        date_click: (object)->
            # console.log "DATE CLICK : ", object, @selected_users
            if @selected_users.length == 1 and 'all' not in @selected_users
                @selected_event.start = object.dateStr+" 12:00:00"
                @selected_event.user_uid = @selected_users[0]
                @dialog_visible = true
            else
                n.warning(@warning_text)
            return

        add_event: ()->
            if @selected_users.length == 1 and 'all' not in @selected_users
                @selected_event.user_uid = @selected_users[0]
                @dialog_visible = true
            else
                n.warning(@warning_text)
            # console.log "ADD EVENT"
            return

        copy_link: ()->
            # select() is only possible on visible element
            el = @$refs.ical_link_ref
            text = document.createElement('textarea')
            text.id = 'temp_area'
            text.textContent = el.innerText
            document.body.append(text)
            text.select()
            document.execCommand("copy")
            text.remove()
            return

        get_ical_link: ()->
            if @selected_users.length == 1 and 'all' not in @selected_users
                # console.log "ICAL LINK", @selected_users[0]
                for u in @app_users
                    if u.uid == @selected_users[0]
                        @ical_link = settings.backend_url+"/app_user/ical/"+u.ical
                        break
                @ical_dialog_visible = true
            else
                n.warning(@ical_warning_text)
            # console.log "ICAL LINK", @ical_link
            return

        event_drag_start: (info)->
            # console.log "EVENT DRAG START", info
            if info.event.extendedProps.item_type == 'Événement'
                @trash_class = 'active'
            return

        is_event_over_trash: (x, y)->
            # console.log "EVENT OVER TRASH ", x, y
            trash_el_rect = document.getElementById('calendar-trash').getBoundingClientRect()
            # console.log "EVENT OVER TRASH ", trash_el_rect
            left = trash_el_rect.left
            top = trash_el_rect.top
            right = trash_el_rect.width + left
            bottom = trash_el_rect.height + top
            # console.log "EVENT OVER TRASH ", left, top, right, bottom
            # Compare
            if x >= left and y >= top and x <= right and y <= bottom
                return true
            return false

        event_drag_stop: (info)->
            # console.log "DRAG STOP ", info
            if info.event.extendedProps.item_type == 'Événement'
                if @is_event_over_trash(info.jsEvent.clientX, info.jsEvent.clientY)
                    # console.log "DELETE EVENT"
                    @delete_event(info.event.extendedProps.item_uid)
            @trash_class = ''
            return

        event_did_mount: (info)->
            # console.log "EVENT DID MOUNT INFO info ", info
            # console.log "EVENT DID MOUNT INFO info event ", info.event.extendedProps.placement
            # console.log "EVENT DID MOUNT INFO info el ", info.el
            # console.log "EVENT DID MOUNT INFO info el fcSeg", info.el.fcSeg

            PopoverClass = Vue.extend(Popover)
            instance = new PopoverClass({
                propsData: {
                    trigger: 'hover',
                    placement: 'bottom',
                    reference: info.el,
                    width: '250'
                    appendToBody: false,
                    title: info.event.extendedProps.item_type,
                }
            })
            # instance.$slots.default = ['Click me!']
            instance.$mount() # pass nothing

            ContentClass = Vue.extend(popover_content)
            content_instance = new ContentClass({
                propsData: {
                    event: info.event
                }
            })
            content_instance.$mount()

            info.el.parentElement.appendChild(instance.$el)
            instance.$el.children[0].appendChild(content_instance.$el)
            # info.el.setAttribute("v-popover:"+"hu"+(info.event.extendedProps.item_uid).toString(), '')
            return

        delete_event: (event_uid)->
            # console.log  "DELETE EVENT", event_uid
            self = @
            m.run('delete_object', ['event', event_uid])
            .then (resp)->
                # console.log "DELETE EVENT", resp.body.data.event_deletion
                if resp.body.data.event_deletion.ok
                    n.success()
                    self.refetch_events()
                    # Closes selected Event once deleted
                    self.reset_selected_event()
                    self.dialog_visible = false
                else
                    n.gql_error("planning: delete_event: then", resp.body.data.event_deletion.message)
            .catch (resp)->
                n.catch_error(resp, "planning: delete_event()")
            return

        save: (info)->
            # console.log "SAVE EVENT"
            event_obj = {}
            event_obj.name = info.event.title
            event_obj.start = t.python_date_formatter(info.event.start)
            end = info.event.end
            if info.event.allDay
                end = new Date(info.event.end.setDate(info.event.end.getDate()-1))
                # console.log "$$$ END ", end
            event_obj.end = t.python_date_formatter(end)
            event_obj.uid = info.event.extendedProps.item_uid
            event_obj.allday = info.event.allDay
            event_obj.user_uid = info.event.extendedProps.user_uid
            self = @
            m.run('save_event', [event_obj])
            .then (resp)->
                if resp.body.data.event_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.event_form_mutation.errors.length > 0
                    for error in resp.body.data.event_form_mutation.errors
                        n.error(error.field, error.messages[0])
                    info.revert()
                else
                    n.success()
                    self.refetch_events()
                    # console.log "SUCCESS "
            .catch (resp)->
                info.revert()
                n.catch_error(resp, "planning: save()")
            return

        save_form: ()->
            # console.log "SAVE FORM EVENT", @selected_event
            self = @
            m.run('save_event', [@selected_event])
            .then (resp)->
                if resp.body.data.event_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.event_form_mutation.errors.length > 0
                    self.errors = resp.body.data.event_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    self.reset_selected_event()
                    self.dialog_visible = false
                    self.refetch_events()
                    # console.log "SUCCESS "
            .catch (resp)->
                n.catch_error(resp, "planning: save_form()")
            return
        get_event_types: ()->
            if @has_access_right('events_show')
                @event_type_set.push({'value':'events', 'label': 'Événements'})
            # if @has_access_right('holidays_show') or @has_access_right('holidays_self_edit')
            #     @event_type_set.push({'value':'holidays', 'label': 'Congés'})
            if @has_access_right('absences_show') or @has_access_right('absences_self_edit')
                @event_type_set.push({'value':'absences', 'label': 'Absences'})
            if @has_access_right('formations_show') or @has_access_right('formations_self_edit')
                @event_type_set.push({'value':'formations', 'label': 'Formations'})
            if @has_access_right('interviews_show') or @has_access_right('interviews_self_edit')
                @event_type_set.push({'value':'interviews', 'label': 'Entretiens'})
            @event_types_ready = true
            @refetch_events()
            return

        get_app_users: ()->
            self = @
            q.run('get_app_user_set', [@$store.getters.current_company.uid, 'calendar'])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("planning: get_app_users: then", e.message)
                else
                    # console.log "GET APP USERS : ", resp.body.data.app_user_set
                    self.app_users.push({'uid':'all', 'fullnamejobs': 'Tout le monde'})
                    self.app_users = self.app_users.concat(resp.body.data.app_user_set)
                    self.app_users_ready = true
                    self.refetch_events()
            .catch (resp)->
                n.catch_error(resp, "planning: get_app_users()")
            return

        get_establishments: ()->
            self = @
            q.run('get_establishment_set', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("planning: get_establishments: then", e.message)
                else
                    # console.log "GET ESTABLISHMENTS : ", resp.body.data.establishment_set
                    self.establishments = self.establishments.concat(resp.body.data.establishment_set)
                    self.establishments_ready = true
                    self.refetch_events()
            .catch (resp)->
                n.catch_error(resp, "planning: get_establishments()")
            return

        get_calendar_events: (info, successCallback, failureCallback)->
            # console.log "GET INFO ", info
            self = @
            # console.log "GET INFO ", @establishments_ready, @app_users_ready, @event_types_ready
            if @establishments_ready and @app_users_ready and @event_types_ready
                q.run('get_calendar_event_set', [@$store.getters.current_company.uid, @selected_establishments, @selected_event_types, @selected_users, @with_subordinates, info.startStr, info.endStr])
                .then (resp)->
                    if resp.body.errors? and resp.body.errors.length > 0
                        for e in resp.body.errors
                            n.gql_error("planning: get_calendar_events: then", e.message)
                    else
                        # console.log "GET EVENTS : ", resp.body.data.calendar_event_set
                        successCallback(resp.body.data.calendar_event_set)
                .catch (resp)->
                    n.catch_error(resp, "planning: get_calendar_events()")
            return
            
    beforeMount: ()->
        # @three_months = [Date.now().getMonth(), Date.now().getMonth()+1, Date.now().getMonth()+2]
        # console.log "THREE MONTH ", @three_months
        @get_event_types()
        if @has_establishments_right
            @get_establishments()
        else
            @establishments_ready = true
            @refetch_events()
        @get_app_users()

    # mounted: ()->
    #     console.log "CALENDAR MOUNTED"
}
